module.exports = __webpack_public_path__ + "ba4b4eae9a14c1b4a4f488d446b1db9d.svg";